(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    function loadProductRecommendations(sectionEl) {
      var url = sectionEl.dataset.baseUrl
        + '?section_id=product-recommendations'
        + '&product_id=' + sectionEl.dataset.productId
        + '&limit=' + sectionEl.dataset.limit;

      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          sectionEl.innerHTML = tmp.querySelector('.product-recommendations').innerHTML;
        });
    }

    var el = document.querySelector('.product-recommendations');
    if (el) loadProductRecommendations(el);

    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === 'product-recommendations') {
        var el = document.querySelector('.product-recommendations');
        if (el) loadProductRecommendations(el);
      }
    });
  
  } catch(e) { console.error(e); }
})();
})();
